//
// # GenAlpha Project Configuration Schema
//
// Configuration for GenAlpha projects specifying PDK and stack selections.
//

// NPM Imports
import typia from "typia";

// # Project Configuration
// Specifies the PDK and stack to use for a GenAlpha project or design session
export interface ProjectConfig {
  // PDK identifier - must match keys in GenAlphaSchema/pdks.json: "gf12", "asap7-pdk", "ga_testlib-pdk"
  pdkId: string;

  // Stack identifier (e.g., "asap7", "10M_3Mx_4Cx_2Kx_1Gx_LB")
  stackId: string;

  // Optional project metadata
  projectName?: string;
  description?: string;
  version?: string;
}

// Default configuration (ASAP7 with its single stack)
export const DEFAULT_PROJECT_CONFIG: ProjectConfig = {
  pdkId: "asap7-pdk",
  stackId: "asap7",
};

// Typia-generated validator
export const validateProjectConfig = typia.createValidate<ProjectConfig>();
